export default {

  intToMoney (value) {
    return new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: 'MXN',
      minimumFractionDigits: 0 // Sin decimales
    }).format(value)
  }

}
